/*
 * @Author: 王峥 wangzheng_jzb@tal.com
 * @Date: 2024-10-15 17:58:35
 * @LastEditors: 王峥 wangzheng_jzb@tal.com
 * @LastEditTime: 2024-10-16 14:04:40
 * @FilePath: /fe-react-template/src/store/HomeStore/index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { makeAutoObservable, runInAction } from 'mobx';
import { isPlainObject } from 'lodash-es';

import { getListApi } from '@service/index';
export class HomeStore {
    list: Array<IHomeStore.List> = [];
    name: string = 'pc and moblie public tamplate';

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    getList = async () => {
        try {
            const res: any = await getListApi();

            runInAction(() => {
                const { code, obj } = res;
                if (code === 200) {
                    this.list = isPlainObject(obj) ? obj?.list : [];
                } else {
                    console.log(res);
                }
            });
            return res;
        } catch (e) {
            console.log(e);
        }
    };
}

export default new HomeStore();
